import type { ApiRoutes } from '@tempo-io/integration-insights-app/rpc';
import { createHonoRpcClient } from './hono-rpc-client';

export const getIntegrationInsightsServiceApi = createHonoRpcClient<ApiRoutes>(
  '/api/integration-insights/v1/',
);
